import { API } from 'api';
import { AxiosResponse } from 'axios';
import {
	ICitiesListRequest,
	ICitiesListResponse,
	ICityCreateRequest,
	ICityDeleteRequest,
	ICityItem,
	ICityPrefixesListRequest,
	ICityPrefixesListResponse,
	ICityUpdateRequest,
} from 'types';
import { API_URL } from 'utils/enums';

class CitiesService {
	static getCities = async (reqBody: ICitiesListRequest): Promise<AxiosResponse<ICitiesListResponse>> =>
		API.post(API_URL.CITIES_LIST, reqBody);

	static getCityPrefixes = async (reqBody: ICityPrefixesListRequest): Promise<AxiosResponse<ICityPrefixesListResponse>> =>
		API.post(API_URL.CITIES_PREFIXES_LIST, reqBody);

	static getCityShortPrefixes = async (
		reqBody: ICityPrefixesListRequest
	): Promise<AxiosResponse<ICityPrefixesListResponse>> => API.post(API_URL.CITIES_SHORT_PREFIXES_LIST, reqBody);

	static createCity = async (reqBody: ICityCreateRequest): Promise<AxiosResponse<ICityItem>> =>
		API.post(API_URL.CITIES_CREATE, reqBody);

	static updateCity = async (reqBody: ICityUpdateRequest): Promise<AxiosResponse<ICityItem>> =>
		API.post(API_URL.CITIES_UPDATE, reqBody);

	static deleteCity = async (reqBody: ICityDeleteRequest): Promise<AxiosResponse<void>> =>
		API.delete(API_URL.CITIES_DELETE, { data: reqBody });
}

export { CitiesService };
